import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {addDependant, updateDependant} from "../../api/RestCallHelper";
import FormPage from "../baseFormPage/BaseFormPage";
import AutocompleteTextInput, {DataType} from "../../shared/AutocompleteTextInput";
import DatePicker from "../../shared/DatePicker";
import TextInput from "../../shared/TextInput";
import {validateForm} from "../../utils/ValidationUtil";
import FormHeader from "../../shared/FormHeader";
import {ROUTES} from "../../utils/RouteConstants";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import useFetchRelationshipTypes from "../../hooks/useFetchRelationshipTypes";
import {FormButton} from "../../styles/globalStyles"

export default function DependantForm () {

  let history = useHistory();
  let location = useLocation();

  const dispatch = useFeedbackDispatch();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownData, loading] = useFetchRelationshipTypes(dropdownOpen);

  const member = location.state.member;

  const [dependant, setDependant] = useState({
    // claimed: false,
     doe: new Date(),
    // id: 1,
    // idnumber: "11111111111",
    // name: "Nabeel",
    //  relationship: "",
    // surname: "Roy"
  });

  const [formValidated, setFormValidated] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const back = () => {
    if (location.state.last) {
      history.push(location.state.last, { edit : true, member : member});
    } else {
      history.push(ROUTES.DEPENDANTS);
    }
  };

  const close = (event, reason) => {
    console.log("In useFetchRelationshipTypes close callback");
    if (reason === 'clickaway') return;

    back();
    dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
  };


  useEffect(() => {
    if (location.state.edit === true) {
      console.log(location.state);
      setDependant({...location.state.dependant, 
                    relationship : location.state.dependant.relationship
                  });
    }
  }, [location, setDependant]);

  const submit = useCallback(async () => {

    // don't send again while we are sending
    if (isSending) return;

    // update state
    setIsSending(true);

    // send the actual request
    if (location.state.edit) {
      updateDependant(dependant, dispatch, close, history, location);
    } else {
      addDependant(dependant, member, dispatch, close, history, location);
    }

    // once the request is sent, update state again
    if (isMounted.current)
      // only update if we are still mounted
      setIsSending(false);

  }, [isSending, dependant, location, history]); // update the callback if the state changes

  useEffect(() => {
    setFormValidated(validateForm(dependant));
    console.log("dependant", dependant);
  }, [dependant, formValidated]);

  return (
    
    <FormPage
      logger = {console.log(dependant)}

      header =  { 

        <FormHeader
          heading={location.state.edit ? "Edit Dependant" : "Add Dependant"}

          subHeading= {member
              ? ("Member:" + member.name + " " + member.surname)
              : ""}
        />

      } 

      form = {
        <>
        <TextInput
          label="First Name"
          value={dependant.name}
          onChange={(value) => setDependant({ ...dependant, name:value })}
          style={{ margin: "10px" }}
        />

        <TextInput
          label="Last Name"
          value={dependant.surname}
          onChange={(value) => setDependant({ ...dependant, surname:value })}
          style={{ margin: "10px" }}
        />

        <TextInput
          number
          label="ID Number"
          value={dependant.idNumber}
          onChange={(value) => setDependant({ ...dependant, idNumber:value })}
          style={{ margin: "10px" }}
        />

        <DatePicker
          label="DOE"
          value={dependant.doe}
          onChange={(value) => setDependant({ ...dependant, doe: value }) }
          style={{ margin: "10px" }}
        />

        <AutocompleteTextInput
          label = "Select Relationship"
          value = {dependant.relationship}
          onChange = {(value) => setDependant({ ...dependant, relationship: value })}
          optionsList = {dropdownData}
          loading = {loading}
          open = {dropdownOpen}
          setOpen = {setDropdownOpen}
          dataType = {DataType.RELATIONSHIP}
        />
        </>
      }

      buttons = {
        <>
            {formValidated &&
                <FormButton
                    disabled={isSending}
                    onClick={submit}
                >
                {location.state.edit ? "Save" : "Add"} 
                </FormButton>   
            }

            <FormButton
                onClick={back}
                disabled={isSending}
            >
                Back
            </FormButton>
        </>
      }

    />
  );
}
